// Hukuki belgelerin dil kaydı.
//
// Bir dil eklemek: `./<kod>.ts` yaz (yapıyı `./en.ts`'ten kopyala) ve aşağıdaki
// haritaya bir satır ekle. Başka hiçbir yere dokunmak gerekmez.
//
// ⚠️ Belgeler statik olarak import edilir, çünkü /legal sunucuda render edilir ve
// sayfa ilk boyamada tam metni taşımak zorundadır (SEO + yazdırma). Dil sayısı
// arttıkça bu bundle'ı büyütür; bölünmesi gerekirse doğru yer BURASI — çağıranlar
// yalnızca getLegalDocs() görür.
import type { Locale } from "@/i18n/config";
import { defaultLocale } from "@/i18n/config";
import type { LegalDoc } from "./shared";
import { DOCS as cs } from "./cs";
import { DOCS as da } from "./da";
import { DOCS as de } from "./de";
import { DOCS as en } from "./en";
import { DOCS as es } from "./es";
import { DOCS as fr } from "./fr";
import { DOCS as it } from "./it";
import { DOCS as hu } from "./hu";
import { DOCS as nl } from "./nl";
import { DOCS as no } from "./no";
import { DOCS as pl } from "./pl";
import { DOCS as pt } from "./pt";
import { DOCS as ro } from "./ro";
import { DOCS as sr } from "./sr";
import { DOCS as fi } from "./fi";
import { DOCS as sv } from "./sv";
import { DOCS as tr } from "./tr";
import { DOCS as bg } from "./bg";
import { DOCS as ru } from "./ru";
import { DOCS as uk } from "./uk";

const DOCS_BY_LOCALE: Partial<Record<Locale, LegalDoc[]>> = {
  cs,
  da,
  de,
  en,
  es,
  fr,
  it,
  hu,
  nl,
  no,
  pl,
  pt,
  ro,
  sr,
  fi,
  sv,
  tr,
  bg,
  ru,
  uk,
};

export function getLegalDocs(locale: Locale): LegalDoc[] {
  // Çevrilmemiş bir dil, boş bir hukuki sayfa yerine İngilizceyi görür: eksik
  // çeviri bir eksikliktir, kullanıcıyı koşulsuz bırakmak bir hatadır.
  return DOCS_BY_LOCALE[locale] ?? DOCS_BY_LOCALE[defaultLocale] ?? en;
}

export function localesWithLegalDocs(): Locale[] {
  return (Object.keys(DOCS_BY_LOCALE) as Locale[]).filter((l) => DOCS_BY_LOCALE[l]?.length);
}

export { LEGAL_VERSION, MERCHANT } from "./shared";
export type { LegalDoc, LegalSection } from "./shared";
